<div class="selected-roles-div">
    <h4 class="selected-roles-h">Selected Roles</h4>

    <mat-selection-list *ngIf="(this.SiteRoles != null) && (this.SiteRoles.length > 0)"
                        (selectionChange)="this.onRolesSelectionChanged()"
                        class="selected-roles-mat-selection-list">
        <mat-list-option *ngFor="let role of this.SiteRoles"
                         [value]="role.name"
                         [selected]="this.IsSelected(role)">
            {{role.name}}
        </mat-list-option>
    </mat-selection-list>
</div>
